<template>
    <v-form>
        <v-col cols="12" md="12">
            <h2>Consulte aqui suas Irregularidades</h2>
            <v-text-field
                    class="my-3"
                    :rules="rules.plate"
                    @keyup="plate = plate.toUpperCase()"
                    @keyup.enter="modal.notifications = true"
                    v-model="plate"
                    v-mask="'XXXXXXX'"
                    label="Digite a placa do seu veículo">
            </v-text-field>
            <button class="btn-blue w-100"
                    dark
                    :disabled="plate.length !== 7"
                    @click.prevent="modal.notifications = true">
                Consultar Veículo
            </button>
<!--            <div class="d-flex justify-content-around pt-5 mt-3">-->
<!--                <a><img src="@/assets/imgs/img-google-play.png"></a>-->
<!--                <a><img src="@/assets/imgs/img-apple-store.png"></a>-->
<!--            </div>-->
            <v-dialog v-model="modal.notifications" width="80%">
                <v-card>
                    <v-card-title>
                        <h5>Irregularidades do veículo {{plate}}</h5>
                        <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="modal.notifications = false"></i>
                    </v-card-title>
                    <v-card-text>
                        <NotificationList :plate="plate"></NotificationList>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-col>
    </v-form>
</template>

<script>
    import NotificationList from './NotificationList'
    export default {
        name: "SearchPlate",
        components:{NotificationList},
        data:function () {
            return{
                plate:'',
                searchPlate:'',
                modal:{
                    notifications: false,
                },
                rules: {
                    plate: [
                        value => ((value || '').length === 7 || (value || '').length === 0) || 'Digite uma placa de veículo válida',
                    ],
                }
            }
        }
    }
</script>

<style scoped>
    h2{
        text-transform: uppercase;
        font-family: Roboto-Black;
        color: #58595B;
        font-size: 34px;
        margin-bottom: 25px;
    }

    .btn-blue{
        text-transform: capitalize !important;
        background: #000 !important;
        color: #ffffff !important;
        font-family: Roboto-Black !important;
        width: 120px;
        height: 43px !important;
        border-radius: 4px !important;
        padding: 8px 15px !important;
        border: 3px solid #000 !important;
    }
    .btn-blue:hover{
        background: transparent !important;
        color: #000 !important;
    }
</style>
